/**
 * The two kinds of site this app serves, from online_order_configuration.type
 * (and online_order.channel on the orders they take): the restaurant ordering
 * site with pickup/delivery time slots, and the storefront (webshop) with a
 * product grid, product pages and shipping.
 */
export const SalesChannels = {
  ordering: "ordering",
  storefront: "storefront",
} as const;

export type SalesChannel = (typeof SalesChannels)[keyof typeof SalesChannels];
